import { render, staticRenderFns } from "./VButtonClose.vue?vue&type=template&id=6ed2b47f&"
import script from "./VButtonClose.vue?vue&type=script&lang=ts&"
export * from "./VButtonClose.vue?vue&type=script&lang=ts&"
import style0 from "./VButtonClose.vue?vue&type=style&index=0&id=6ed2b47f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports